import { render, staticRenderFns } from "./EmailLogo.vue?vue&type=template&id=728e4ed4&"
import script from "./EmailLogo.vue?vue&type=script&lang=js&"
export * from "./EmailLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports